module.exports = __webpack_public_path__ + "static/media/Good&Co.96f6219f.svg";